import { GenericService } from './generic.service';
import { Injectable } from '@angular/core';
import { AdunitStatsAdapter, AdunitStats } from '../../shared/models/sapi/adunit-stats.model';

@Injectable()
export class AdunitStatsService extends GenericService<AdunitStatsAdapter, AdunitStats> {
	apiPath = 'adstats';

	constructor(protected adunitStatsAdapter: AdunitStatsAdapter) {
		super(adunitStatsAdapter);
	}
}
